import React, { useEffect, useState } from 'react';
import { businessPublicService } from '../../../services/businessApi';
import './ReportIssue.css';

const initialForm = {
  plantId: '', vendorCode: '', categoryId: '', title: '', description: '',
  reportedByName: '', reportedByEmail: '', reportedByPhone: '',
};

// Public, no-login self-service ticket form (Task 6.1) — reachable at /business/report-issue.
export default function ReportIssue() {
  const [plants, setPlants] = useState([]);
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [ticketNumber, setTicketNumber] = useState(null);

  useEffect(() => {
    businessPublicService.listPlants().then(res => setPlants(res.data.plants));
    businessPublicService.listCategories().then(res => setCategories(res.data.categories));
  }, []);

  const update = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const res = await businessPublicService.reportIssue(form);
      setTicketNumber(res.data.ticketNumber);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (ticketNumber) {
    return (
      <div className="report-issue-page">
        <div className="report-issue-card">
          <h1>Thanks — issue reported</h1>
          <p>Your reference number is <strong>{ticketNumber}</strong>. Our team will get back to you shortly.</p>
          <button onClick={() => { setTicketNumber(null); setForm(initialForm); }}>Report another issue</button>
        </div>
      </div>
    );
  }

  return (
    <div className="report-issue-page">
      <div className="report-issue-card">
        <h1>Report an Issue</h1>
        <p className="report-issue-sub">l-setu supplier portal support</p>

        <form onSubmit={handleSubmit}>
          {error && <div className="report-issue-error">{error}</div>}

          <div className="form-group">
            <label>Plant</label>
            <select value={form.plantId} onChange={update('plantId')} required>
              <option value="">Select plant...</option>
              {plants.map(p => <option key={p._id} value={p._id}>{p.name} ({p.code})</option>)}
            </select>
          </div>

          <div className="form-group">
            <label>Your vendor code</label>
            <input value={form.vendorCode} onChange={update('vendorCode')} placeholder="As shown on your PO / L-Setu login" required />
          </div>

          <div className="form-group">
            <label>Issue category</label>
            <select value={form.categoryId} onChange={update('categoryId')} required>
              <option value="">Select category...</option>
              {categories.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
            </select>
          </div>

          <div className="form-group">
            <label>Title</label>
            <input value={form.title} onChange={update('title')} placeholder="Short summary of the issue" required />
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea rows={4} value={form.description} onChange={update('description')} required />
          </div>

          <div className="form-row-3">
            <div className="form-group">
              <label>Your name</label>
              <input value={form.reportedByName} onChange={update('reportedByName')} />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={form.reportedByEmail} onChange={update('reportedByEmail')} />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input value={form.reportedByPhone} onChange={update('reportedByPhone')} />
            </div>
          </div>

          <button type="submit" disabled={submitting}>{submitting ? 'Submitting...' : 'Submit issue'}</button>
        </form>
      </div>
    </div>
  );
}
